const Cities = [
    {
        "id": 1,
        "word": "New York",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 2,
        "word": "Los Angeles",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 3,
        "word": "Chicago",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 4,
        "word": "Houston",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 5,
        "word": "Phoenix",
        "pronunciation": "/ˈfiːnɪks/",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 6,
        "word": "Philadelphia",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 7,
        "word": "San Antonio",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 8,
        "word": "San Diego",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 9,
        "word": "Dallas",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 10,
        "word": "San Jose",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 11,
        "word": "Austin",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 12,
        "word": "Jacksonville",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 13,
        "word": "Fort Worth",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 14,
        "word": "Columbus",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 15,
        "word": "Charlotte",
        "pronunciation": "/ˈʃɑːlət/",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 16,
        "word": "Indianapolis",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 17,
        "word": "San Francisco",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 18,
        "word": "Seattle",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 19,
        "word": "Denver",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 20,
        "word": "Washington",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 21,
        "word": "Nashville",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 22,
        "word": "Oklahoma City",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 23,
        "word": "Boston",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 24,
        "word": "El Paso",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 25,
        "word": "Portland",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 26,
        "word": "Las Vegas",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 27,
        "word": "Memphis",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 28,
        "word": "Detroit",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 29,
        "word": "Baltimore",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 30,
        "word": "Milwaukee",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 31,
        "word": "Albuquerque",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 32,
        "word": "Fresno",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 33,
        "word": "Tucson",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 34,
        "word": "Sacramento",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 35,
        "word": "Kansas City",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 36,
        "word": "Mesa",
        "pronunciation": "/ˈmeɪ.sə/",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 37,
        "word": "Atlanta",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 38,
        "word": "Omaha",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 39,
        "word": "Colorado Springs",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 40,
        "word": "Raleigh",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 41,
        "word": "Long Beach",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 42,
        "word": "Virginia Beach",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 43,
        "word": "Miami",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 44,
        "word": "Oakland",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 45,
        "word": "Minneapolis",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 46,
        "word": "Tulsa",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 47,
        "word": "Bakersfield",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 48,
        "word": "Wichita",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 49,
        "word": "Arlington",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 50,
        "word": "Aurora",
        "pronunciation": "/ɔːˈɹɔː.ɹə/",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 51,
        "word": "Tampa",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 52,
        "word": "New Orleans",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 53,
        "word": "Cleveland",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 54,
        "word": "Honolulu",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 55,
        "word": "Anaheim",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 56,
        "word": "Louisville",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 57,
        "word": "Henderson",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 58,
        "word": "Lexington",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 59,
        "word": "Irvine",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 60,
        "word": "Stockton",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 61,
        "word": "Orlando",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 62,
        "word": "Corpus Christi",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 63,
        "word": "Newark",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 64,
        "word": "Riverside",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 65,
        "word": "St. Paul",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 66,
        "word": "Cincinnati",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 67,
        "word": "San Juan",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 68,
        "word": "Santa Ana",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 69,
        "word": "Greensboro",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 70,
        "word": "Pittsburgh",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 71,
        "word": "Jersey City",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 72,
        "word": "St. Louis",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 73,
        "word": "Lincoln",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 74,
        "word": "Durham",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 75,
        "word": "Anchorage",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 76,
        "word": "Plano",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 77,
        "word": "Chandler",
        "pronunciation": "/ˈtʃændlə(ɹ)/",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 78,
        "word": "Chula Vista",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 79,
        "word": "Buffalo",
        "pronunciation": "/ˈbʌf.əl.əʊ/",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 80,
        "word": "Gilbert",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 81,
        "word": "Madison",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 82,
        "word": "Reno",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 83,
        "word": "North Las Vegas",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 84,
        "word": "Toledo",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 85,
        "word": "Fort Wayne",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 86,
        "word": "Irving",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 87,
        "word": "Lubbock",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 88,
        "word": "St. Petersburg",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 89,
        "word": "Laredo",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 90,
        "word": "Chesapeake",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 91,
        "word": "Winston-Salem",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 92,
        "word": "Glendale",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 93,
        "word": "Garland",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 94,
        "word": "Scottsdale",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 95,
        "word": "Arlington",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 96,
        "word": "Enterprise",
        "pronunciation": "/ˈɛntɚˌpɹaɪz/",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 97,
        "word": "Boise",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 98,
        "word": "Santa Clarita",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    },
    {
        "id": 99,
        "word": "Norfolk",
        "pronunciation": "x",
        "progress": [
            0,
            0,
            0
        ]
    }
]
  export default Cities;







